import { FX_CENTER_ENABLED } from '@services/permissions'

import type { Section } from '../types'

export const tradeConfirmationSection: Section = {
  label: 'layout:page.fx.confirmation.title',
  route: '/fx/confirmation/[id]',
  permissions: FX_CENTER_ENABLED,
}

export const settlementDetailsSection: Section = {
  label: 'layout:page.fx.settlements.title',
  route: '/fx/settlements/[id]',
  permissions: FX_CENTER_ENABLED,
}

export const settlementsSection: Section = {
  label: 'layout:page.fx.settlements.title',
  route: '/fx/settlements',
  permissions: FX_CENTER_ENABLED,
}

export const historySection: Section = {
  label: 'layout:page.fx.history.title',
  route: '/fx/history',
  permissions: FX_CENTER_ENABLED,
}

export const fxSection: Section = {
  label: 'layout:page.fx.trade.title',
  route: '/fx',
  icon: 'SwitchHorizontalOutline',
  permissions: FX_CENTER_ENABLED,
  pages: [
    tradeConfirmationSection,
    settlementsSection,
    historySection,
    settlementDetailsSection,
  ],
}
